import React from "react";

const PreReview = () => {
  return (
    <div className="bg-gray-10 border border-gray-200 p-2  flex flex-col max-w-[300px] ">
      <p className="text-gray-800 text-sm  font-normal">
        <span className="font-bold">Pre Review:</span>The current medication list used for 
        the medication review. 
      </p>
    </div>
  );
};

export default PreReview;
